import { render, staticRenderFns } from "./chat-input.vue?vue&type=template&id=46445880&scoped=true"
import script from "./chat-input.vue?vue&type=script&lang=js"
export * from "./chat-input.vue?vue&type=script&lang=js"
import style0 from "./chat-input.vue?vue&type=style&index=0&id=46445880&prod&lang=scss&scoped=true"
import style1 from "./chat-input.vue?vue&type=style&index=1&id=46445880&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46445880",
  null
  
)

export default component.exports